var SelectedModal = {};
var st;
SelectedModal.init = function () {
  SelectedModal.universal(document.getElementById('js-sizeguide-modal'));
  SelectedModal.universal(document.getElementById('js-shipping-details-modal'));
  SelectedModal.appendEvent(document.getElementsByClassName('js-sg'), 'js-sizeguide-modal');
  SelectedModal.appendEvent(document.getElementsByClassName('js-sd'), 'js-shipping-details-modal');
  SelectedModal.appendEvent(document.getElementsByClassName('js-returns'), 'js-returns-modal');
  SelectedModal.appendEvent(document.getElementsByClassName('js-pageModal'), 'js-page-modal');
  SelectedModal.appendEvent(document.getElementsByClassName('js-pageModal2'), 'js-page-modal2');
  SelectedModal.hide(document.getElementsByClassName('js-close-sg')[0], document.getElementById('js-sizeguide-modal'));
  SelectedModal.hide(document.getElementsByClassName('js-close-sd')[0], document.getElementById('js-shipping-details-modal'));
  SelectedModal.hide(document.getElementsByClassName('js-close-returns')[0], document.getElementById('js-returns-modal'));
  SelectedModal.hide(document.getElementsByClassName('js-close-page')[0], document.getElementById('js-page-modal'));
  SelectedModal.hide(document.getElementsByClassName('js-close-page2')[0], document.getElementById('js-page-modal2'));
};
SelectedModal.appendEventFromWrap = function (wrapper) {
  if (!wrapper) return;
  SelectedModal.appendEvent(wrapper.querySelectorAll('.js-sg'), 'js-sizeguide-modal');
  SelectedModal.appendEvent(wrapper.querySelectorAll('.js-sd'), 'js-shipping-details-modal');
  SelectedModal.appendEvent(wrapper.querySelectorAll('.js-returns'), 'js-returns-modal');
  SelectedModal.appendEvent(wrapper.querySelectorAll('.js-pageModal'), 'js-page-modal');
  SelectedModal.appendEvent(wrapper.querySelectorAll('.js-pageModal2'), 'js-page-modal2');
};
SelectedModal.appendEvent = function (els, targetId) {
  if (els.length === 0) return;
  for (var i = 0; i < els.length; i++) {
    SelectedModal.show(els[i], document.getElementById(targetId));
  }
};
SelectedModal.show = function (eleParent, eleChild) {
  if (!eleParent) {
    return;
  }
  if (!eleChild) {
    return;
  }
  eleParent.addEventListener('click', function () {
    eleChild.classList.add('modal-is-active');
    // st = $('html, body').scrollTop();
    st = window.scrollY;
    document.body.style.overflowY = 'hidden';
    if (window.innerWidth < 992) {
      setTimeout(function () {
        document.getElementsByClassName('wrap')[0].style.position = 'fixed';
        document.body.style.pointerEvents = 'none';
      }, 400);
    }
  });
};
SelectedModal.hide = function (eleCloseBtn, eleChild) {
  if (!eleCloseBtn) {
    return;
  }
  if (!eleChild) {
    return;
  }
  eleCloseBtn.addEventListener('click', function () {
    eleChild.classList.remove('modal-is-active');
    document.body.style.overflowY = 'auto';
    if (window.innerWidth < 992) {
      document.getElementsByClassName('wrap')[0].style.position = 'relative';
      document.body.style.pointerEvents = 'auto';
      $('html, body').animate({
        scrollTop: st
      }, 0);
    }
  });
};
SelectedModal.universal = function (eleChild) {
  if (!eleChild) {
    return;
  }
  eleChild.onclick = function (event) {
    if (event.target == eleChild) {
      eleChild.classList.remove('modal-is-active');
      document.body.style.overflowY = 'auto';
      if (window.innerWidth < 992) {
        document.getElementsByClassName('wrap')[0].style.position = 'relative';
        document.body.style.pointerEvents = 'auto';
        $('html, body').animate({
          scrollTop: st
        }, 0);
      }
    }
  };
};
SelectedModal.init();
window.SelectedModal = SelectedModal;


// WEBPACK FOOTER //
// ./scripts/components/selected-modal.js